import { Typography } from '@tempmee/react';
import { Center } from '~/commonComponents';
import AnimatedCheckCircle from '~/components/shared/AnimatedCheckCircle';
import { ConfirmPopupContent } from '~/components/shared/ConfirmPopupContent';
import browserHistory from '~/browserHistory';
import { routes } from '~/routes';
import { NumberUtils } from '~/utils/NumberUtils';
import { incidentTypes } from '../utils/incidentPopupUtil';

const NoShowDescription = ({ professionalName }) => {
  const phoneNumber = NumberUtils.getCSPhone().formatted;

  return (
    <Typography as="span" textAlign="center" style={{ marginTop: 30, marginBottom: -40 }}>
      We&apos;re sorry this happened. A no-show throws off your whole day, and we want to make this
      right.
      <br />
      <br />
      This shift will be canceled and you will be refunded.
      <br />
      <br />
      If you still need coverage, we recommend reposting the shift right away. If{' '}
      <strong>{professionalName}</strong> is scheduled for upcoming shifts at your office and
      you&apos;d like to make changes, please call us at {phoneNumber}.
    </Typography>
  );
};

const WalkedOutDescription = ({ professionalName }) => {
  const phoneNumber = NumberUtils.getCSPhone().formatted;

  return (
    <Typography as="span" textAlign="center" style={{ marginTop: 30, marginBottom: -40 }}>
      We&apos;re sorry this happened. When a professional leaves early, you shouldn&apos;t have to
      chase down the paperwork.
      <br />
      <br />
      The payout for this shift is on hold until you submit a shift adjustment.
      <br />
      <br />
      At the end of the day, submit a shift adjustment so <strong>{professionalName}</strong> is
      paid only for hours actually worked. If you&apos;d prefer not to work with{' '}
      <strong>{professionalName}</strong> again, leave a 2-star rating or lower to unlock the option
      to block them from your office.
      <br />
      <br />
      If <strong>{professionalName}</strong> is scheduled for upcoming shifts, please call us at{' '}
      {phoneNumber} and we&apos;ll help.
    </Typography>
  );
};

export const SuccessReport = ({ data, onClose, incidentType }) => {
  const professionalName = data?.professionalName ?? '';
  const isNoShow = incidentType === incidentTypes.noShow;

  return (
    <ConfirmPopupContent
      Icon={() => (
        <Center marginBottom={20}>
          <AnimatedCheckCircle />
        </Center>
      )}
      title="Professional Successfully Reported"
      description={
        isNoShow ? (
          <NoShowDescription professionalName={professionalName} />
        ) : (
          <WalkedOutDescription professionalName={professionalName} />
        )
      }
      leftButtonStyle={{ width: 180 }}
      leftButtonAction={() => {
        onClose();
        browserHistory.push(routes.help);
      }}
      leftButtonText="Contact Support"
      rightButtonStyle={{ width: 180 }}
      rightButtonAction={onClose}
      rightButtonText="Return"
    />
  );
};
